import { defineRequest } from "../axios"
import type { SendingConfigurationResponse, UpdateSendingConfigurationPayload } from "./types"

// 取得預覽與寄件人管理設定
export const getSendingConfiguration = defineRequest<SendingConfigurationResponse>({
    url: "/systems/sending-configuration/",
    method: "get",
})

// 更新預覽與寄件人管理設定
export const updateSendingConfiguration = defineRequest<void, UpdateSendingConfigurationPayload>({
    url: "/systems/sending-configuration/",
    method: "put",
})
